// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const PdiPin = t.struct({
    pin: t.String
}, {
    name: 'PdiPin',
    strict: true
});

export const getDefaultState = () => new PdiPin({
    pin: ''
});

export default PdiPin;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/pdi-pin.js